<template>
  <div id="mobileStoryContainer" ref="mobileStory" class="mobile-story">
    <MobileHeader />
    <template v-if="activeAppLoaded">
      <div ref="storyContainer" class="story-container">
        <TTReader class="mt-1" :panel="storyKeys.SIDEBAR_TOP" />
        <SidebarWidgets v-if="showSidebarWidgets" data-test="sidebar-widgets" />
        <TTReader hide-if-empty :panel="storyKeys.SIDEBAR_BOT" />
      </div>
      <OrbVizLegal class="px-1" />
      <div class="sticky-gradient" />
    </template>
    <div v-else />
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { StoryKeys } from '@/types'
import SummaryTable from '@/components/public/SummaryTable/SummaryTable.vue'
import OrbVizLegal from '@/components/admin/OrbVizLegal.vue'
import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import MobileHeader from '@/components/public/mobile/MobileHeader.vue'
import StoryWidgetsMixin from '@/mixins/StoryWidgetsMixin'
import ComparisonGraph from '../Charts/ComparisonGraph.vue'
import SidebarWidgets from '@/components/public/SidebarWidgets.vue'

const components = {
  MobileHeader,
  TTReader,
  SummaryTable,
  OrbVizLegal,
  ComparisonGraph,
  SidebarWidgets,
}

@Component({ components })
export default class MobileStory extends StoryWidgetsMixin {
  storyKeys = StoryKeys

  get activeAppLoaded() {
    return this.$typedStore.activeVisualisation.appLoaded
  }

  get showSidebarWidgets() {
    return this.$typedStore.activeVisualisation.displaysTreeData
  }
}
</script>

<style lang="scss" scoped>
.mobile-story {
  position: relative;
  color: var(--story-foreground);
  background-color: var(--story-background);
  flex: 1;
  min-height: 0;
  overflow-y: scroll;
  .story-container {
    padding: 0 1em 0 max(1em, env(safe-area-inset-left));
  }
  .sticky-gradient {
    position: sticky;
    height: 20px;
    width: 100%;
    bottom: 0;
    background-image: linear-gradient(to bottom, transparent, var(--story-background));
  }
}
</style>
